import { render, staticRenderFns } from "./DetailImgShow.vue?vue&type=template&id=e3a9ad3c&scoped=true&"
import script from "./DetailImgShow.vue?vue&type=script&lang=js&"
export * from "./DetailImgShow.vue?vue&type=script&lang=js&"
import style0 from "./DetailImgShow.vue?vue&type=style&index=0&id=e3a9ad3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9ad3c",
  null
  
)

export default component.exports